import ACTIONS from '@/store/storeActions';

const actions = {
  [ACTIONS.CURRENT_CHOICE]: (context, payload ) => context.commit(ACTIONS.CURRENT_CHOICE, payload),
  [ACTIONS.RESULT]: (context, payload) => context.commit(ACTIONS.RESULT, payload),
  [ACTIONS.GET_RESULTS]: (context, payload) => { context.commit(ACTIONS.GET_RESULTS, payload) },
}

export default actions
